///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../abstract-command';
import { ActivityDTO } from '../../../../services/project-socket/activity-dto.model';
import { GtthNodeFeatureDtoModel } from '../../../../services/project-socket/dto/gtth-node-feature-dto.model';
import { GtthPreloaderModalEvent } from '../../../../shared/preloader-modal/preloader-modal-event';
import { GtthModifyUnitInfoCommand } from './node/modify-unit-info-command';

export class GtthModifyNodesAttributes extends GtthAbstractCommand {
    private originNodes: GtthNodeFeatureDtoModel[];
    private modifiedNodes: GtthNodeFeatureDtoModel[];

    create(nodes: GtthNodeFeatureDtoModel[]): this {
        this.modifiedNodes = nodes;
        this.originNodes = this.modifiedNodes.map((node) => this.historyService.logicalTopology.getStation(node.getId()).toGeoJson());
        return this;
    }

    getCommandName(): string {
        return 'GtthModifyNodesAttributes';
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.nodes = this.modifiedNodes;
        this.sendActivity(activity);
    }

    undoCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.nodes = this.originNodes;
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.modifyNodes(activityDto);
    }

    undoCommandActivity(activityDto: ActivityDTO): void {
        this.modifyNodes(activityDto);
    }

    private modifyNodes(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.eventManager.broadcast({
                name: 'togglePreloaderModal',
                eventObject: GtthPreloaderModalEvent.hide()
            });

            this.historyService.notificationService.showError(activityDto?.error?.message);

            if (this.commandResolve) {
                this.commandResolve(activityDto.successful);
            }
        } else {
            const nodeModifyCommands = [];

            for (const updatedNode of activityDto.nodes) {
                nodeModifyCommands.push(
                    this.historyService.doCommandBypassHistory(
                        this.historyService.command(GtthModifyUnitInfoCommand).createFromObject(updatedNode),
                        true
                    )
                );
            }

            Promise.all(nodeModifyCommands).then((_nodesCreateRes) => {
                if (this.commandResolve) {
                    this.commandResolve(true);
                }

                this.historyService.eventManager.broadcast({
                    name: 'togglePreloaderModal',
                    eventObject: GtthPreloaderModalEvent.hide()
                });
            });
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }
}
